var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3704 6.375C16.3704 9.89581 13.6219 12.75 10.2315 12.75C9.61128 12.75 9.01255 12.6545 8.44821 12.4769L6.13889 14.875H4.09259V17H0V12.75L4.35561 8.22686C4.18456 7.64081 4.09259 7.01906 4.09259 6.375C4.09259 2.85418 6.84107 0 10.2315 0C13.6219 0 16.3704 2.85418 16.3704 6.375ZM10.2315 2.125C9.66641 2.125 9.20833 2.6007 9.20833 3.1875C9.20833 3.7743 9.66641 4.25 10.2315 4.25C11.3616 4.25 12.2778 5.2014 12.2778 6.375C12.2778 6.9618 12.7359 7.4375 13.3009 7.4375C13.866 7.4375 14.3241 6.9618 14.3241 6.375C14.3241 4.02779 12.4918 2.125 10.2315 2.125Z",
    fill: "#889EBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.0edffbe9.svg";
export { ForwardRef as ReactComponent };